import { CardUIExtension, ICardModel, ICardUIExtensionContext, IControlViewModel } from 'tessa/ui/cards';
import { ButtonViewModel } from 'tessa/ui/cards/controls';
import { Card } from 'tessa/cards';
import { showError, showLoadingOverlay } from 'tessa/ui';
import { PkCommonHelper } from 'src/pkScripts/Helpers/PkCommonHelper';
import { CardGetFileContentRequest, CardService } from 'tessa/cards/service';
import { CdFileTypes } from '../Helpers/CdFileTypes';
import { CdCardTypes } from '../Helpers/CdCardTypes';

export class CdDownloadAllFilesZipUIExtension extends CardUIExtension {

  public initialized(context: ICardUIExtensionContext) {
    let model: ICardModel;
    if ((model = context.model) == null) {
      return;
    }

    if (!model.controls.has('DownloadAllFilesZip')) return;
    let downloadAllFilesZipControl: IControlViewModel | undefined = model.controls.get('DownloadAllFilesZip');
    if (!downloadAllFilesZipControl) return;
    let downloadAllFilesZipButton = downloadAllFilesZipControl as ButtonViewModel;

    downloadAllFilesZipButton.executeOnClick = async () => {
      downloadAllFilesZipButton.isReadOnly = true;
      let card: Card = model.card;
      let zipFileName: string = this.GetFileName(card);
      zipFileName += '.zip';

      try {
        await showLoadingOverlay(async () => {
          const getFileContentRequest = new CardGetFileContentRequest();
          getFileContentRequest.fileTypeName = CdFileTypes.GetZipArchiveType;
          getFileContentRequest.cardId = card.id;

          const getFileContentResponse = await CardService.instance.getFileContent(getFileContentRequest);
          if (getFileContentResponse.content == null || getFileContentResponse.size === 0) {
            throw new Error('Вернулся пустой файл.');
          }

          PkCommonHelper.SaveFileContent(zipFileName, getFileContentResponse.content);
        }, "Формирование zip архива.");
      } catch (err) {
        showError(err);
      }

      downloadAllFilesZipButton.isReadOnly = false;
    };
  }

  GetFileName(card: Card): string {

    let fileName: string;
    let number: string;
    if (card.sections.has('DocumentCommonInfo') && card.sections.get('DocumentCommonInfo')?.fields.has('SecondaryFullNumber')) {
      number = card.sections.get('DocumentCommonInfo')?.fields.get('SecondaryFullNumber');
    }
    else {
      number = card.id;
    }

    fileName = number;

    // TES-9149 для Технической документации свой формат имени  ID_<Шифр раздела><Объект>
    if (card.typeId == CdCardTypes.TechnicalDocumentationTypeID) {
      if (card.sections.has('PkRdProperties')) {
        let divisionCipher: string = card.sections.get('PkRdProperties')?.fields.get('RdDivisionCipher');
        let objectName: string = card.sections.get('PkRdProperties')?.fields.get('ObjectName');

        fileName = number + '_' + divisionCipher + '_' + objectName;
        fileName = fileName.replace('/', '_');
        fileName = fileName.replace(/[/\\?%*:|"<>]/g, '');
      }
    }

    return fileName
  }
}